export default {
  // Navigation
  nav_home: "Laman Utama",
  nav_products: "Produk",
  nav_about: "Tentang Kami",
  nav_support: "Sokongan",
  nav_contact: "Hubungi",

  // Hero Section
  hero_title: "Alat Muzik Taishan",
  hero_subtitle: "Alat Muzik Premium Buatan China",
  hero_description: "Berdedikasi untuk pembuatan alat muzik loyang berkualiti tinggi sejak 1987",
  hero_cta: "Terokai Produk",

  // Products Section
  products_title: "Produk Kami",
  products_subtitle: "Alat muzik loyang profesional, dibuat dengan kecemerlangan",
  product_trumpet: "Siri Trompet",
  product_trumpet_desc: "Alat muzik loyang profesional dengan nada terang dan penuh, sesuai untuk semua majlis persembahan",
  product_trombone: "Siri Trombone",
  product_trombone_desc: "Tindakan slaid yang lancar, julat luas, digemari oleh orkestra profesional",
  product_saxophone: "Siri Saksofon",
  product_saxophone_desc: "Nada yang kaya dan lembut, sempurna untuk muzik jazz dan klasik",
  product_horn: "Siri French Horn",
  product_horn_desc: "Nada lembut dan hangat, penting untuk orkestra simfoni",
  product_clarinet: "Siri Klarinet",
  product_clarinet_desc: "Alat muzik tiupan kayu klasik dengan nada yang jelas dan menawan",
  product_flute: "Siri Seruling",
  product_flute_desc: "Nada yang renyah dan merdu, ideal untuk persembahan solo dan ensemble",
  view_details: "Lihat Butiran",

  // Product Catalog
  catalog_title: "Muat Turun Katalog Produk",
  catalog_description: "Muat turun katalog lengkap Taishan Instruments untuk spesifikasi produk terperinci",
  catalog_download: "Muat Turun Katalog",

  // About Section
  about_title: "Tentang Kami",
  about_subtitle: "Lebih 30 tahun warisan ketukangan",
  about_heading: "Tentang Alat Muzik Taishan",
  about_p1: "Syarikat Pembuatan Alat Muzik Loyang Taishan Shandong telah ditubuhkan pada tahun 1987 dan merupakan pengeluar alat muzik loyang profesional terkemuka di China. Terletak di Wilayah Shandong, syarikat ini mempunyai pangkalan pengeluaran moden dan pasukan R&D profesional.",
  about_p2: "Pada tahun 2004, produk syarikat telah diuji oleh Pusat Penyeliaan dan Pemeriksaan Kualiti Alat Muzik Kementerian Kebudayaan dan semuanya memenuhi piawaian kebangsaan. Pada tahun 2006, syarikat berjaya menjadi unit semakan langsung dan dianugerahkan gelaran 'Perusahaan Kuat dalam Industri Alat Muzik China'.",
  about_p3: "Syarikat telah lulus pensijilan sistem kualiti ISO9001 dan pensijilan sistem alam sekitar ISO14001. Produk dieksport ke banyak negara dan wilayah di seluruh dunia dan dipercayai oleh pencinta muzik dan penghibur profesional.",
  about_year: "Ditubuhkan",
  about_series: "Siri Produk",

  // Timeline
  timeline_title: "Perjalanan Kami",
  timeline_1987: "Syarikat ditubuhkan, memberi tumpuan kepada pembuatan alat muzik loyang",
  timeline_2001: "Menjadi ahli Pameran Alat Muzik Antarabangsa China",
  timeline_2004: "Produk lulus pemeriksaan oleh Pusat Penyeliaan Kualiti Alat Muzik Kementerian Kebudayaan, memenuhi piawaian kebangsaan",
  timeline_2006: "Dianugerahkan gelaran 'Perusahaan Kuat dalam Industri Alat Muzik China'",
  timeline_2013: "Alat muzik loyang Taishan menjadi jenama China yang bersaing dengan jenama terkenal antarabangsa",
  timeline_2019: "Dianugerahkan gelaran SME 'Khusus, Halus, Tersendiri dan Inovatif' oleh Jabatan Sains dan Teknologi Wilayah Shandong",

  // Support Section
  support_title: "Sokongan & Perkhidmatan",
  support_subtitle: "Sistem perkhidmatan selepas jualan profesional",
  support_quality: "Jaminan Kualiti",
  support_quality_desc: "Diperakui ISO9001, setiap produk menjalani ujian yang ketat",
  support_service: "Perkhidmatan Selepas Jualan",
  support_service_desc: "Pasukan selepas jualan profesional menyediakan penyelenggaraan dan perundingan",
  support_maintenance: "Pembaikan & Penyelenggaraan",
  support_maintenance_desc: "Perkhidmatan pembaikan dan penyelenggaraan alat muzik profesional",
  support_guide: "Panduan Pengguna",
  support_guide_desc: "Arahan penggunaan terperinci dan garis panduan penyelenggaraan",

  // FAQ
  faq_title: "Soalan Lazim",
  faq_q1: "Bagaimana saya memilih alat muzik loyang yang sesuai?",
  faq_a1: "Kami mengesyorkan memilih berdasarkan tahap permainan, gaya muzik dan bajet anda. Pemula boleh memilih produk peringkat kemasukan, manakala penghibur profesional boleh memilih siri mewah. Pasukan perkhidmatan pelanggan kami boleh memberikan nasihat profesional.",
  faq_q2: "Apakah tempoh waranti?",
  faq_a2: "Produk kami datang dengan waranti satu tahun. Isu kualiti di bawah penggunaan biasa akan dibaiki atau diganti secara percuma.",
  faq_q3: "Bagaimana saya menyelenggara alat muzik loyang?",
  faq_a3: "Kami mengesyorkan membersihkan bahagian dalam alat muzik selepas setiap penggunaan, kerap melincirkan injap dan slaid, mengelakkan perlanggaran dan suhu melampau. Sila rujuk manual produk untuk garis panduan penyelenggaraan terperinci.",
  faq_q4: "Adakah anda menawarkan penghantaran antarabangsa?",
  faq_a4: "Ya, produk kami dijual ke banyak negara dan wilayah di seluruh dunia. Sila hubungi pasukan jualan kami untuk kaedah penghantaran khusus dan kos.",

  // Contact Section
  contact_title: "Hubungi Kami",
  contact_subtitle: "Kami berharap dapat mendengar daripada anda",
  contact_info: "Maklumat Hubungan",
  contact_address: "Alamat",
  contact_address_value: "Wilayah Shandong, China",
  contact_phone: "Telefon",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "Sembang di WhatsApp",
  contact_email: "E-mel",
  contact_email_value: "Sila tinggalkan mesej melalui borang, kami akan membalas secepat mungkin",
  contact_hours: "Waktu Perniagaan",
  contact_hours_value: "Isnin hingga Jumaat 9:00-18:00",
  contact_form_title: "Tinggalkan Mesej",
  contact_form_name: "Nama",
  contact_form_email: "E-mel",
  contact_form_phone: "Telefon",
  contact_form_message: "Mesej",
  contact_form_submit: "Hantar",
  contact_form_name_placeholder: "Sila masukkan nama anda",
  contact_form_email_placeholder: "Sila masukkan e-mel anda",
  contact_form_phone_placeholder: "Sila masukkan nombor telefon anda",
  contact_form_message_placeholder: "Sila masukkan mesej anda (maksimum 500 aksara)",
  contact_form_required: "Diperlukan",
  contact_form_success: "Berjaya dihantar! Kami akan menghubungi anda tidak lama lagi.",
  contact_form_error: "Penghantaran gagal, sila cuba lagi kemudian.",
  contact_form_validate_required: "Sila isi semua medan yang diperlukan",
  contact_form_validate_email: "Sila masukkan alamat e-mel yang sah",
  contact_form_validate_message: "Mesej tidak boleh melebihi 500 aksara",

  // Footer
  footer_description: "Berdedikasi untuk pembuatan alat muzik loyang berkualiti tinggi, menyediakan produk cemerlang untuk pencinta muzik dan penghibur profesional.",
  footer_quick_links: "Pautan Pantas",
  footer_contact_us: "Hubungi Kami",
  footer_address: "Alamat: Wilayah Shandong, China",
  footer_hours: "Waktu Perniagaan: Isnin hingga Jumaat 9:00-18:00",
  footer_copyright: "Hak cipta terpelihara.",
  footer_powered: "Dikuasakan oleh Readdy"
};
